'use client'
import { memo } from "react";
import { DpRichContentWrapper } from "@/styles/product";
export default memo(function RichComponent({ data, className }: any) {
  return <DpRichContentWrapper className={className} dangerouslySetInnerHTML={{ __html: data || '' }} />
})